import appStore from '../../../shared/stores/app.store';
import { UserAuthType } from '../../../shared/types/userAuth.type';
import authService from '../../../shared/services/auth.service';
import openNotificationWithIcon from '../../../shared/components/OpenNotificationWithIcon/OpenNotificationWithIcon';
import { computed } from 'mobx';
import { t } from '../../../shared/i18n/util';

class AuthStore {
  private errorType = new Map([
    ['403', t('msgErrorAuth')],
    ['404', t('msgErrorAuth')],
    ['500', t('msgError500')]
  ]);

  @computed
  get loading(): boolean {
    return appStore.isLoading;
  }

  onFinish = async values => {
    try {
      appStore.setIsLoading(true);
      const data = {
        email: values.email,
        password: values.password
      };
      const userAuth: UserAuthType = await authService.login(data);

      if (userAuth) {
        appStore.setUserAuthData(userAuth);
        authService.loginBrowser({ ...userAuth });
        window.location.pathname = 'main/farm';
      }
    } catch (e) {
      appStore.setIsLoading(false);
      const msg = this.errorType.get(e.message) ?? e.message;
      openNotificationWithIcon('error', `${msg}`, '');
    }
  };
}

export default AuthStore;
